export function clearZreissProducts() {
  return {
    type: "CLEAR_ZREISS_PRODUCTS",
  };
}
